
<template>
  <div id="app" :data-theme="theme">
    <Sidebar></Sidebar>
    <Header @toggle-theme="toggleTheme"></Header>
    <Main></Main>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/Header/TheHeader.vue';
import Main   from './components/Main/TheMain.vue'    ;
import Footer from './components/Footer/TheFooter.vue';
import Sidebar from './components/Sidebar/Sidebar.vue';

export default {
  name: 'app',
  components: { Header, Main, Footer, Sidebar },
  data() {
    return { theme: 'dark' }
  },
  created() {
    let themeFromLocalStorage = localStorage.getItem('theme');
    if (themeFromLocalStorage === 'light' || themeFromLocalStorage === 'dark') {
      this.theme = themeFromLocalStorage;
    }
  },
  methods: {
    toggleTheme: function() {
      (this.theme === 'dark') ? this.theme = 'light': this.theme = 'dark';
      localStorage.setItem('theme', this.theme)
    }
  },
}
</script>

<style>
:root {
  --border-radius: 4.5px;
  --todo-footer-font-size: 13px;
  --todo-footer-height: 44px;
}

#app[data-theme="dark"] {
  --bg-clr: hsl(235, 21%, 11%);
  --bg-todo-clr: hsl(235, 24%, 19%);
  --title-clr: hsl(0, 0%, 98%);
  --circle-border-clr: hsl(233, 14%, 35%);
  --todo-text-clr: hsl(234, 39%, 85%);
  --todo-border-clr: hsl(234, 14%, 27%);
  --todo-completed-text-clr: hsl(233, 14%, 35%);
  --todo-footer-clr: hsl(234, 11%, 44%);
  --todo-footer-hover-clr: var(--todo-text-clr);
  --todo-footer-btn-active: hsl(220, 98%, 61%);
  --footer-text-clr: hsl(235, 14%, 36%);
  --ghost-clr: hsl(235, 24%, 25%);
  --todoList-shadow: 0px 20px 25px rgba(0, 0, 0, 0.2),
                     0px 30px 50px rgba(0, 0, 0, 0.3);
  --menu-color: black;
}

#app[data-theme="light"] {
  --bg-clr: hsl(0, 0%, 98%);
  --bg-todo-clr: hsl(236, 33%, 92%);
  --title-clr: hsl(0, 0%, 98%); /* same value */
  --circle-border-clr: hsl(233, 11%, 84%); /* not sure if this the right one */
  --todo-text-clr: hsl(235, 19%, 35%);
  --todo-border-clr: hsl(236, 9%, 61%);
  --ghost-clr: hsl(236, 33%, 98%);
  --todoList-shadow: 4px 8px 11px 0px rgba(212, 212, 212, 0.388),
                    18px 20px 50px 5px rgba(0, 0, 0, 0.102);   
  --menu-color: white;
}

*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  font-family: "Josefin Sans", sans-serif;
  color: var(--todo-text-clr);
  user-select: none;
}

html {
  font-size: 18px;
}

body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--bg-clr);
}

button {
  cursor: pointer;
}

#app {
  --bg-img-width: clamp(202px, 53.29vw, 300px);

  display: grid;
  place-items: center;
  align-content: start;
  min-height: 100vh;
  padding-bottom: 1em;
  box-sizing: border-box;

  background-repeat: no-repeat;
  background-size: 100% var(--bg-img-width);
  background-color: var(--bg-clr);
}

#app[data-theme="dark"]  { background-image: url("assets/bg-desktop-dark.jpg")}
#app[data-theme="light"] { background-image: url("assets/bg-desktop-light.jpg")}


@media screen and (max-width: 25rem) { /* 400px */
   #app[data-theme="dark"]  { background-image: url(./assets/bg-mobile-dark.jpg)}
   #app[data-theme="light"] { background-image: url(./assets/bg-mobile-light.jpg)}
  /* .add-todo{--add-todo-height: 48px;} */
}
</style>
